import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Icon, Table } from 'semantic-ui-react'

import { ACCESS_LEVELS } from 'app'

import { Avatar } from 'images/src'

import { actions, selectors } from '../../redux'

import type { FC } from 'react'

interface PermissionsProps {
  institutionId: string
}

const Permissions: FC<PermissionsProps> = ({ institutionId }) => {
  const dispatch = useDispatch()
  const permissions = useSelector(selectors.permissions)

  useEffect(() => {
    if (permissions.key !== institutionId && !permissions.loading && !permissions.loaded) {
      dispatch(actions.permissionsFetch({ institutionId }))

      return () => {
        dispatch(actions.permissionsFetchCancel())
      }
    }

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //
  return (
    <div className="Permissions flex flex-col gap-2 p-2">
      <div className="flex flex-col gap-2 p-2 rounded bg-white">
        <div className="text-lg font-bold">Personas con acceso</div>
        <div>
          <Table celled collapsing compact selectable singleLine striped structured unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Nombre</Table.HeaderCell>
                <Table.HeaderCell>E-mail</Table.HeaderCell>
                <Table.HeaderCell>Acceso</Table.HeaderCell>
                <Table.HeaderCell />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {permissions.data.map((permission) => (
                <Table.Row key={permission.id}>
                  <Table.Cell>
                    <Link className="flex items-center gap-1 p-1" to={`/user/${permission.user.id}`}>
                      <Avatar size="2em" src={permission.user.profile.avatar} />
                      {permission.user.profile.first_name} {permission.user.profile.last_name}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>{permission.user.email}</Table.Cell>
                  <Table.Cell>
                    {[
                      permission.level & ACCESS_LEVELS.ADMIN ? 'ADMIN' : '',

                      permission.level & ACCESS_LEVELS.EDITOR ? 'EDITOR' : '',

                      permission.level & ACCESS_LEVELS.REPORTER ? 'REPORTER' : '',
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </Table.Cell>
                  <Table.Cell>
                    <Icon
                      circular
                      className="!m-0 cursor-pointer !opacity-30"
                      color="red"
                      name="trash alternate outline"
                      // onClick={console.log}
                      role="button"
                      title="Eliminar permiso"
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
      <div className="flex flex-col gap-2 p-2 rounded bg-white">
        <div className="text-lg font-bold">Agregar persona</div>
        <div>... UNDER CONSTRUCTION ...</div>
      </div>
    </div>
  )
}

export default Permissions
